import ct from "class-types.macro";
import React from "react";
import { CategoryDetailImageResult } from "~/common/Store/models/Category";

export interface OutletShopPopularProduct {
  label: string;
  itemCount: number;
  filterUrl: string;
  image: CategoryDetailImageResult;
}

interface Props {
  popularProducts: OutletShopPopularProduct[];
}

const OutletShopPopularProducts = ({ popularProducts }: Props) => {
  return popularProducts?.length > 0 ? (
    <div className={ct("container")}>
      <div
        data-component="outlet-popular-products"
        className={ct(
          "flex",
          "flex-col",
          "flex-wrap",
          "justify-center",
          "-mt-32",
          "sm:flex-row",
        )}
      >
        {popularProducts.map((product: OutletShopPopularProduct) => (
          <div
            className={ct(
              "box-border",
              "flex",
              "flex-row",
              "p-3",
              "py-1",
              "sm:flex-col",
              "sm:py-3",
              "sm:w-3/6",
              "md:justify-center",
              "lg:flex-1",
              "lg:w-auto",
            )}
          >
            {product.image && (
              <a
                href={product.filterUrl}
                className={ct(
                  "bg-white",
                  "border-gray-100",
                  "rounded",
                  "border-solid",
                  "border",
                  "flex",
                  "flex-row",
                  "items-center",
                  "flex-grow",
                  "p-3",
                  "shadow-md",
                  "sm:flex-col",
                  "sm:justify-between",
                  "md:p-6",
                  "md:text-center",
                )}
              >
                <img
                  src={product.image.medium}
                  alt={product.label}
                  className={ct("mr-4", "w-3/12", "sm:mx-auto", "sm:w-9/12")}
                  aria-hidden="true"
                  style={{ maxWidth: "200px" }}
                />
                <div className="w-full">
                  <p
                    className={ct(
                      "font-semibold",
                      "text-xl",
                      "mb-0",
                      "text-gray-900",
                    )}
                  >
                    {product.label}
                  </p>
                  <span className={ct("block", "text-sm", "leading-6")}>
                    {`Shop ${product.itemCount} Product${
                      product.itemCount !== 1 ? "s " : " "
                    }`}
                    <i className="icon-breadcrumb" />
                  </span>
                </div>
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  ) : null;
};
export default OutletShopPopularProducts;
